export const FILTERED_OPTIONS = {
  NO_TABLES: "NO_TABLES",
  FILTERED_ONLY: "FILTERED_ONLY",
  FULL_DATA: "FULL_DATA",
};
